import { createContext, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { SalesService } from 'lib/api'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { useResErrors } from '../../../hooks'
import { MISSED } from '../../../constants/deals'
import { parseJson } from '../../../lib/utils'

export const WorkListViewRopStoreContext = createContext({
  store: {},
  actions: {}
})

export const WorkListViewStoreProviderRop = props => {
  const { id } = useParams()
  const { standardCheck } = useResErrors()
  const [wlData, setWlData] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleRopCheck = async val => {
    setLoading(true)

    const data = {
      id: wlData?.id,
      globalId: wlData?.globalId,
      ropCheck: val
    }

    await SalesService.updateSale(data).then(res =>
      standardCheck(res, ({ data }) => {
        getSale()
      })
    )
    setLoading(false)
  }

  const handleApproveDiscount = async (isApproved = false) => {
    setLoading(true)

    const data = {
      id: wlData?.car?.id,
      globalId: wlData?.globalId,
      discountApprovedByRop: isApproved
    }

    await SalesService.updateSaleCar(data).then(res =>
      standardCheck(res, ({ data }) => {
        getSale()
      })
    )
    setLoading(false)
  }

  const handleUpdateStatus = async status => {
    if (status) {
      setLoading(true)

      const data = {
        id: wlData?.id,
        globalId: wlData?.globalId,
        saleStatusCode: status
      }
      if (status === MISSED) {
        await SalesService.updateSale({
          id: wlData?.id,
          globalId: wlData?.globalId,
          closedByRop: true,
          clientDeclined: true
        }).then(res => standardCheck(res, ({ data }) => {}))
      }
      if (wlData?.car) {
        await SalesService.updateSaleCar({
          id: wlData?.car.id,
          discountValue: -1,
          discountApprovedByRop: null
        }).then(res => standardCheck(res, ({ data }) => {}))
      }
      await SalesService.updateSaleStatus(data).then(res =>
        standardCheck(res, ({ data }) => {
          getSale()
        })
      )
      setLoading(false)
    }
  }

  useEffect(() => {
    getSale()
  }, [id])

  const getSale = async () => {
    if (id) {
      setLoading(true)
      await SalesService.getSaleByIdForView(id).then(response =>
        standardCheck(response, ({ data }) => {
          setWlData({ ...data, commentsRSE: parseJson(data?.commentsRSE, {}) })
        })
      )
      setLoading(false)
    }
  }
  const store = {
    wlData,
    loading
  }

  const actions = {
    setLoading,
    handleRopCheck,
    handleApproveDiscount,
    handleUpdateStatus,
    getSale
  }

  return (
    <WorkListViewRopStoreContext.Provider value={{ store, actions }}>
      {props.children}
      <LoaderBackdrop loading={loading} />
    </WorkListViewRopStoreContext.Provider>
  )
}

export default WorkListViewStoreProviderRop

export const useWorkListViewRopStore = () =>
  useContext(WorkListViewRopStoreContext)

export const withWorkListViewStore = Component => props =>
  (
    <WorkListViewRopStoreContext.Consumer>
      {state => <Component {...props} {...state} />}
    </WorkListViewRopStoreContext.Consumer>
  )
